import {Controller} from "stimulus"

var delayTimer;
export default class extends Controller {

    connect() {
        console.log("log from permitting-search controller");
        Array.from(document.querySelector('.selected-parcels').querySelectorAll('.result-location'))
            .map(parcel => {
                parcel.classList.add('result-parcel');
            });
        Array.from(document.querySelector('.selected-parcels').querySelectorAll('.delete-action'))
            .map(parcel => parcel.classList.remove('hidden'));

    }

    getDelayedReport(e) {
        clearTimeout(delayTimer);
        delayTimer = setTimeout(function () {
            reloadReport();
        }, 2100)

    }

    removeParcel(e) {
        e.preventDefault()
        const parcel = e.target.closest('.result-parcel');
        const selectedParcels = document.querySelector('.selected-parcels').querySelector('.results-list');
        selectedParcels.removeChild(parcel);
        reloadReport()
    }

    getReport(e) {
        reloadReport();
    }
}

function reloadReport() {
    // const postingDate = document.getElementById('report_date').value;
    const active = document.getElementById('active').checked;
    const outstandingPaymentsField = document.getElementById('outstanding_payments');
    const outstandingPayments = outstandingPaymentsField ? outstandingPaymentsField.checked : false;
    // const ccOnly = document.getElementById('cc_only').checked;
    // const activitySourceControls = document.querySelectorAll('.activity-source')
    const selectedParcelDoms = document.querySelector('.selected-parcels').querySelectorAll('.result-parcel');
    const selectedParcels = Array.from(selectedParcelDoms).map(parcel => parcel.id);
    const selectedBusinessDoms = document.querySelector('.new-business-form').querySelectorAll('.business');
    const selectedBusinesses = Array.from(selectedBusinessDoms).map(business => business.id);
    const selectedTemplates = Array.from(document.getElementById('permitting_app_template_id')
        .querySelectorAll(':checked')).map(option => option.value)
    const jurisdiction = document.getElementById("jurisdiction").value
    const censusCode = document.getElementById("permitting_census_code_id").value
    const projectName = document.getElementById("name").value
    const appliedSince = document.getElementById("frame_start").value
    const appliedUntil = document.getElementById("frame_end").value
    const approvedSince = document.getElementById("approved_start").value
    const approvedUntil = document.getElementById("approved_end").value
    const reportType = document.getElementById("report_type").value
    console.log("finding permits for report ");
    window.location.href = "/permitting/applications?active=" + active + "&report_type=" + reportType +
        "&outstanding_payments=" + outstandingPayments +
        "&jurisdiction=" + jurisdiction + "&parcels=" + encodeURIComponent(selectedParcels) +
        "&businesses=" + encodeURIComponent(selectedBusinesses) +
        "&census_code=" + encodeURIComponent(censusCode) +
        "&app_template_ids=" + encodeURIComponent(selectedTemplates) +
        "&name=" + encodeURIComponent(projectName) + "&frame_start=" +
        encodeURIComponent(appliedSince) + "&frame_end=" + encodeURIComponent(appliedUntil) +
        "&approved_start=" + encodeURIComponent(approvedSince) + "&approved_end=" + encodeURIComponent(approvedUntil);
}
